module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Explosion.0df72f20.svg";